module.exports = __webpack_public_path__ + "static/media/fade_frame.58b6ed94.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/fade_frame.png
// module id = 50
// module chunks = 0